// extracted by mini-css-extract-plugin
module.exports = {"root":"select_root__YidIe"};